import UserResourceModel from '../../generated/types/model/resource/UserResourceModel';

export default class UserResourceViewModel extends UserResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
